import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {
    CertificateRequestDto
} from 'src/app/shared/model/certificate-trade-details.model';
import { VesselUnknownDTO } from 'src/app/shared/model/one-time-scope-change-t-and-c.model';
import {createRequestOption} from 'src/app/shared/util/request-util';


// type EntityResponseType = HttpResponse<CertificateRequestDto>;
// type EntityArrayResponseType = HttpResponse<IPortMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class CertificateDtoMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/certificate-requests';
    private certificateRequestFavouriteUrl = SERVER_API_URL + 'api/certificate-requests/favourite';
    private draftCertificate = SERVER_API_URL + "api/certificate-requests-drafts";
    private _vesselUnknownNameImo: string = SERVER_API_URL + "api/add-vessel-name-or-imo-to-request";
    constructor(private http: HttpClient) { }

    create(certificateDto: CertificateRequestDto): Observable<any> {
        //    // const copy = this.convertDateFromClient(certificateDto);
        //     return this.http
        //         .post<any>(this.resourceUrl, certificateDto, { observe: 'response' })
        //         .map((res: any) => this.convertDateFromServer(res));

        return this.http.post<any>(this.resourceUrl, certificateDto, { observe: 'response' });
    }

    update(certificateDto: CertificateRequestDto): Observable<any> {
        return this.http.put<any>(this.resourceUrl, certificateDto, { observe: 'response' });
    }

    find(id: number): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    draftFind(id: number): Observable<any> {
        return this.http.get<any>(`${this.draftCertificate}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get<any[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(certificateDto: any): any {
        const copy: any = Object.assign({}, certificateDto.shipmentDetailsDTO, {
            dateOfShipment:
                certificateDto.shipmentDetailsDTO.dateOfShipment != null && certificateDto.shipmentDetailsDTO.dateOfShipment.isValid()
                    ? certificateDto.shipmentDetailsDTO.dateOfShipment.toJSON()
                    : null
        });
        return copy;
    }
    markCertificateRequestAsFavourite(id: number, name: any) {
        return this.http.put<any>(`${this.certificateRequestFavouriteUrl}/${id}/${name}`, { observe: 'response' });
    }

    private convertDateFromServer(res: any): any {
        res.body.dateOfShipment = res.body.dateOfShipment != null ? moment(res.body.dateOfShipment) : null;
        return res;
    }

    downloadFileService(fileId: string): Observable<Blob> {
        const _url = SERVER_API_URL + 'api/file/get/' + fileId;
        return this.http.get(_url, { responseType: 'blob' }).map(blob => {
            return blob;
        });
    }

    get(url: string): Observable<any> {
        return this.http.get<any>(`${SERVER_API_URL}${url}`, { observe: 'response' });
    }


    saveInsurerData(crId,subIns,asDraft): Observable<any> {
        return this.http.post<any>(SERVER_API_URL+'api/certificate-request/save-subscribing-insures/'+crId+'/'+asDraft,subIns, { observe: 'response' });
    }

    vesselNameImoUnknown(certificateRequestId: number, vesselUnknownDto: VesselUnknownDTO): Observable<any> {
        return this.http.post<any>(this._vesselUnknownNameImo+'/'+certificateRequestId, vesselUnknownDto, { observe: 'response' });
    }

}
